import { FC } from 'react';

import ProductTypeListing from 'components/main/ProductType';

const ProductType: FC = () => <ProductTypeListing />;

export default ProductType;
